/**
 * Extrae el código de error de una respuesta de API.
 * Busca en múltiples ubicaciones posibles del objeto error.
 */
export const extractErrorCode = (error: any): string | null => {
  return (
    error?.errorCode ||
    error?.data?.errorCode ||
    error?.response?.data?.errorCode ||
    error?.error?.errorCode ||
    null
  );
};
